import { User } from './user';

export class BaseDTO {
    Id: number;
    Active =  true;
    IsActive = true;
    Deleted = false;
    CreatedAt: string;
    CreatedBy: User;
    UpdatedAt: string;
    UpdatedBy: User;
    LastTimestamp: string;
}
